'use strict';
angular.module('dokiv')
  .factory('CompanyFeedService', ['$translate', function($translate) {
    return {
      feedTranslator: function(f, userType) {
        var router;
        switch (f.action) {
          case 'ENTER_COMPANY':
          case 'LEAVE_COMPANY':
          case 'LOGIN':
          case 'LOGOUT':
          case 'RESET_PASSWORD':
            f.extra.objectTypeName = f.extra.objectType;
            return {
              router: router,
              feed: f,
              type: 1
            };

          case 'CREATE':
            f.extra.objectTypeName = f.extra.objectType;
            if (userType === 'DEFAULT') {
              if (f.extra.objectType === 'PUBLICATION') {
                router = 'root.company.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
                f.extra.objectTypeName = 'OBJECT';
              } else if (f.extra.objectType === 'CUSTOMER') {
                router = 'root.company.customers-dashboard.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
              } else if (f.extra.objectType === 'CHECKLIST') {
                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
              }
            } else {
              if (f.extra.objectType === 'PUBLICATION') {
                router = 'root.company-guest.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
                f.extra.objectTypeName = 'OBJECT';
              }
            }
            return {
              router: router,
              feed: f,
              type: 2
            };

          case 'UPDATE':
          case 'VERIFY':
          case 'CHECK':
          case 'UNCHECK':
          case 'DONE':
          case 'DELETE':
          case 'FILE_INVISIBLE':
          case 'FILE_VISIBLE':
          case 'FILE_UPLOADED':
          case 'FILE_DOWNLOADED':
          case 'FORM_SUBMIT':
          case 'SHARED':
          case 'SEND':
            var modifiedProperty = null;
            f.extra.objectTypeName = f.extra.objectType;
            if (f.extra.objectType === 'PUBLICATION') {
              f.extra.objectTypeName = 'OBJECT';
              if (userType === 'DEFAULT') {
                router = 'root.company.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
              } else {
                router = 'root.company-guest.' + angular.lowercase(f.extra.objectType) + '.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
              }
              var textMore = '';
              if (f.extra.newData) {
                if (f.extra.newData.Features) {
                  break;
                }
                var objectKey = Object.keys(f.extra.newData).length > 1 ? Object.keys(f.extra.newData)[Object.keys(f.extra.newData).length -1] : Object.keys(f.extra.newData)[0];
                textMore += (f.extra.newData.Priority ? (' to ' + f.extra.newData.Priority.name) : '') + (f.extra.newData.Reference ? (' to ' + f.extra.newData.Reference) : '');
                if (objectKey === 'Parent') {
                  if (f.extra.newData.Parent) {
                    modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('publication.activity.history.set-parent') + textMore;
                  } else {
                    modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('publication.activity.history.unset-parent') + textMore;
                  }
                } else if (objectKey === 'Status') {
                  if (f.extra.newData.Status === 'DELETED') {
                    break;
                  }
                  modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('notification.actions.change-status', {status: $translate.instant('publication.' + angular.lowercase(f.extra.newData.Status))});
                } else {
                  if(objectKey){
                    modifiedProperty = $translate.instant('notification.actions.updated') + ': ' + $translate.instant('publication.activity.history.' + objectKey) + textMore;
                  }
                }
              } else if (f.action === 'FILE_INVISIBLE' || f.action === 'FILE_VISIBLE' || f.action === 'FILE_UPLOADED') {
                modifiedProperty = $translate.instant('notification.actions.' + f.action, {
                  fileName: f.extra.fileName
                });
              } else if (f.action === 'FILE_DOWNLOADED') {
                modifiedProperty = $translate.instant('notification.actions.FILE_DOWNLOADED');
              } else if (f.action === 'DELETE') {
                textMore += (f.extra.inforName ? (" keypass " + f.extra.inforName) : "");
                modifiedProperty = $translate.instant('notification.actions.deleted') + textMore;
              } else if (f.action === 'SHARED') {
                router = 'root.company.publication.shares({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
                if (f.extra.action === 'CREATE_SHARE') {
                  modifiedProperty = $translate.instant('publication.activity.shared', {email: f.extra.email});
                } else if (f.extra.action === 'END_SHARE') {
                  modifiedProperty = $translate.instant('publication.activity.end-shared');
                } 
              } else if (f.extra.inforName){
                modifiedProperty = $translate.instant('notification.actions.updated') + ': keypass ' + $translate.instant('notification.named') + " " + f.extra.inforName;
              } else if (f.action === 'VERIFY'){
                modifiedProperty = $translate.instant('notification.actions.verified');
              }
            } else {
              if (f.action === 'CHECK' || f.action === 'UNCHECK' || f.action === 'DONE') {
                modifiedProperty = $translate.instant('publication.activity.history.' + angular.lowercase(f.action), {
                  user:     f.performedBy.name,
                  checkItem: f.extra.checkItem,
                  checklist: f.extra.object.name
                });
                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
              } else if (f.action === 'UPDATE') {
                modifiedProperty = $translate.instant('notification.actions.updated');
                if (f.extra.objectType === 'CUSTOMER') {
                  router = 'root.company.customers-dashboard.detail({companyId: "' + f.companyId + '", ' + angular.lowercase(f.extra.objectType) + 'Id: "' + f.extra.object.id + '"})';
                }
              } else if (f.action === 'DELETE') {
                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
                modifiedProperty = f.performedBy.name + ' ' +$translate.instant('notification.actions.deleted');
              } else if (f.action === 'FORM_SUBMIT') {
                router = 'root.company.publication.detail({companyId: "' + f.companyId + '", publicationId: "' + f.objectId + '"})';
                modifiedProperty = $translate.instant('notification.actions.' + f.action, {formName: f.extra.humanReadableID});
              } else if (f.action === 'SEND') {
                modifiedProperty = $translate.instant('notification.actions.sent-email');
              }
            }
            return {
              router: router,
              modifiedProperty: modifiedProperty,
              feed: f,
              type: 3
            };

          case 'JOIN':
          case 'LEFT':
          case 'GRANTED_PERMISSION':
          case 'REMOVED_PERMISSION':
          case 'INVITED':
            f.extra.objectTypeName = f.extra.objectType;
            modifiedProperty = $translate.instant('notification.actions.' + f.action);
            if (f.action === 'GRANTED_PERMISSION' || f.action === 'REMOVED_PERMISSION') {
              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
                permission: f.extra.permission,
                user: f.extra.user.name
              });
            } else if (f.action === 'INVITED') {
              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
                email: f.extra.object.email
              });
            } else if (f.action === 'JOIN') {
              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
                user: f.extra.object.name
              });
            } else if (f.action === 'LEFT') {
              modifiedProperty = $translate.instant('notification.actions.' + f.action, {
                user: f.extra.user.name
              });
            }
            return {
              router: router,
              modifiedProperty: modifiedProperty,
              feed: f,
              type: 4
            };
        }
      }
    };
  }]);


//////////////////
// WEBPACK FOOTER
// ./scripts/app/CompanyFeedService.js
// module id = 238
// module chunks = 0